import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PackageAvailabilityNotifyButton } from '../..';
import { PACKAGE_QUANTITY_BADGE_VARIANTS } from '../../PackageQuantityBadge/PackageQuantityBadge';
import css from '../PackagePricingPanel.module.css';

const PackageBadgesAvailability = ({
  isAvailable,
  outOfBookingRange,
  formattedPackageAvailableDate,
  availabilityPackageBadges,
  setIsPackageAvailabilityModalOpen,
  isOnWaitingList,
}) => {
  const notifyButton = (
    <PackageAvailabilityNotifyButton
      onClick={() => {
        setIsPackageAvailabilityModalOpen(true);
      }}
    />
  );

  const getNotified = (
    <div className={css.getNotified}>
      {isOnWaitingList ? (
        <b>
          <FormattedMessage id="PackagePage.waitingListNotified" />
        </b>
      ) : (
        <FormattedMessage id="PackagePricingPanel.soldOutgetNotified" />
      )}
    </div>
  );

  let badge;

  if (!isAvailable) {
    badge = {
      variant: PACKAGE_QUANTITY_BADGE_VARIANTS.DANGER,
      text: (
        <FormattedMessage
          id="PackagePricingPanel.soldOutSimple"
          values={{ date: formattedPackageAvailableDate }}
        />
      ),
    };
  } else if (outOfBookingRange) {
    badge = {
      variant: PACKAGE_QUANTITY_BADGE_VARIANTS.WARNING,
      text: (
        <FormattedMessage
          id="PackagePricingPanel.outOfRange"
          values={{ date: formattedPackageAvailableDate }}
        />
      ),
    };
  }

  if (!badge) {
    return null;
  }

  return (
    <>
      <div className={css.badgeWrapper}>{availabilityPackageBadges}</div>

      {!isOnWaitingList && notifyButton}

      {getNotified}
    </>
  );
};

export default PackageBadgesAvailability;
